import { DataGrid, DataGridProps, GridColDef, GridLocaleText } from "@mui/x-data-grid";
import { styled } from "@mui/material/styles";
import { heIL } from "@mui/x-data-grid/locales";
import {
  DataGridCustomToolbar,
  localeText,
} from "./UIParts/DataGridCustomToolbar";
import { Box } from "@mui/material";


interface StyledDataGridProps extends DataGridProps {
  autoExpand?: boolean;
  maxHeight?: number | string;
  enableStickyColumns?: boolean;
}

const StyledDataGrid = styled(
  ({ autoExpand = true, maxHeight, sx, ...rest }: StyledDataGridProps) => {
    const computedHeight = autoExpand ? "auto" : "100%";

    return (
      <Box
        sx={{
          width: "100%",
          maxHeight: maxHeight ?? "600px",
          display: "flex",
          flexDirection: "column",
          overflow: "auto",
        }}
      >
        <DataGrid
          {...rest}
          localeText={localeText}
          getRowHeight={() => "auto"}
          disableRowSelectionOnClick={rest.disableRowSelectionOnClick ?? true}
          initialState={{
            ...rest.initialState,
            pagination: {
              paginationModel: { pageSize: 100, page: 0 },
              ...rest.initialState?.pagination,
            },
          }}
          pageSizeOptions={[100]}
          pagination
          slots={{
            toolbar: rest.slots?.toolbar || (() => <DataGridCustomToolbar />),
          }}
          sx={{
            flex: 1,
            minHeight: 0,
            height: "100%", // ⬅ חשוב!
            "& .MuiDataGrid-virtualScroller": {
              overflowY: "auto",
            },
            "& .MuiDataGrid-columnHeaders": {
              position: "sticky",
              top: 0,
              zIndex: 2,
              backgroundColor: "#f5f5f5",
            },
            "& .MuiDataGrid-footerContainer": {
              position: "sticky",
              bottom: 0,
              zIndex: 2,
              backgroundColor: "#fff",
            },
            
           "& .MuiDataGrid-virtualScrollerContent .MuiDataGrid-cell[data-colindex='0']": {
              paddingRight: "21px",
            },
            // "&  .MuiDataGrid-columnHeaders > div:nth-of-type(1)": {
            //   paddingRight: "23px",
            // },
           
            ...sx,
          }}
        />
      </Box>
    );
  }
)(({ theme }) => ({
  border: 0,
  fontFamily: [
    "-apple-system",
    "BlinkMacSystemFont",
    '"Segoe UI"',
    "Roboto",
    '"Helvetica Neue"',
    "Arial",
    "sans-serif",
    '"Apple Color Emoji"',
    '"Segoe UI Emoji"',
    '"Segoe UI Symbol"',
  ].join(","),
  WebkitFontSmoothing: "auto",
  letterSpacing: "normal",

  // ✅ רקע לכותרות
  "& .MuiDataGrid-columnHeaders": {
    backgroundColor: "#f5f5f5",
  },

  // ✅ כותרות עם גלישת טקסט (wrap)
  "& .MuiDataGrid-columnHeader": {
    whiteSpace: "normal",
    wordBreak: "break-word",
    overflow: "visible",
    textAlign: "center",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    padding: "8px",
    flexWrap: "wrap",
    minHeight: "48px", // מוודא שלא תהיה קריסה
  },
 
"& .MuiDataGrid-row.Mui-selected": {
  backgroundColor: "#e3f2fd !important",
  "&:hover": {
    backgroundColor: "#bbdefb !important",
  },
},
"& .MuiDataGrid-columnHeaderTitle": {
  whiteSpace: "normal",
  wordBreak: "break-word",
  textAlign: "center",
  lineHeight: "1.2",
},

  // ✅ מרכוז תוכן בכל התאים
  "& .MuiDataGrid-cell": {
    textAlign: "right",
    display: "flex",
    alignItems: "center",
    justifyContent: "right",
  },

  // ✅ הוספת גבול בין עמודות
  "& .MuiDataGrid-columnHeader, & .MuiDataGrid-cell": {
    borderRight: "1px solid #ddd",
  },

  // ✅ שורות מתחלפות (striped rows)
  "& .MuiDataGrid-row:nth-of-type(odd)": {
    backgroundColor: "#f9f9f9",
    "&:hover": {
      backgroundColor: "#e1e1e1", // ✅ צבע Hover לשורות אי-זוגיות
    },
  },
  "& .MuiDataGrid-row:nth-of-type(even)": {
    backgroundColor: "#ffffff",
    "&:hover": {
      backgroundColor: "#e1e1e1", // ✅ צבע Hover לשורות זוגיות
    },
  },

  // ✅ קו תחתון בין השורות
  "& .MuiDataGrid-row": {
    borderBottom: "1px solid #ddd",
  },

  // ✅ התאמה למצב כהה (dark mode)
  ...(theme.palette.mode === "dark"
    ? {
        "& .MuiDataGrid-columnHeaders": {
          backgroundColor: "#424242",
        },
        "& .MuiDataGrid-row:nth-of-type(odd)": {
          backgroundColor: "#303030",
        },
        "& .MuiDataGrid-cell": {
          color: "#ffffff",
        },
      }
    : {}),
}));

export default StyledDataGrid;
